import React from 'react';
import Empty from '../../Layouts/Empty';
import { Form } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { validationSchema } from './validation';
import { Button, Input, Alert } from '../../UI/Common';

const LoginPage = (props) => {
  const { error, t, isSubmitting } = props;
  const form = {
    username: '',
    password: '',
  };
  // process.env.PUBLIC_URL +
  return (
    <Empty>
      <h1 className="text-center">
        <img src={window.configs.LOGIN_LOGO} width="300" alt="Logo" />
      </h1>
      <Formik
        initialValues={form}
        validationSchema={validationSchema}
        onSubmit={(values) => props.onLogin(values)}
      >
        {({ values, handleChange, errors, touched, handleSubmit }) => {
          return (
            <Form>
              <Input
                required
                label="Username"
                id="username"
                autoCapitalize="off"
                placeholder="Username"
                value={values.username}
                onChange={handleChange('username')}
                invalid={touched.username && errors.username}
                error={errors.username}
              />
              <Input
                required
                label="Password"
                type="password"
                id="password"
                placeholder={t('Password')}
                value={values.password}
                onChange={handleChange('password')}
                invalid={touched.password && errors.password}
                error={errors.password}
              />
              <Alert.Error hasIcon text={t(error)} />
              <div className="form-group form-group-button">
                <Button
                  id="login-button"
                  type="submit"
                  classes="button-block"
                  loading={isSubmitting}
                  onClick={handleSubmit}
                >
                  {t('Login')}
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Empty>
  );
};

export default withTranslation('app')(LoginPage);
